import React from 'react';

export const sceneFourMeta = {
  id: 'future-learning',
  title: '場景四｜未來學習力夏令營',
  excerpt: 'AI × 森林探索，讓孩子學會一生自主學習，而不是只為考試背答案。',
};

const SceneFourFutureLearning: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneFourMeta.title}</h2>
    <h3>AI × 森林探索：「讓孩子學會一生自主學習」</h3>
    <p>清晨的陽光，穿過森林樹梢。</p>
    <p>孩子們坐在木桌前，不是低頭死背課本，而是：</p>
    <ul>
      <li>用 AI 練英文對話</li>
      <li>用 AI 理解數學</li>
      <li>用 AI 觀察植物</li>
      <li>用 AI 探索星空與宇宙</li>
    </ul>
    <p>森林裡沒有填鴨。只有：好奇。</p>
    <p>一個孩子拍下地上的葉子，AI 告訴他這是什麼植物、來自什麼生態、需要什麼土壤。</p>
    <p>孩子第一次發現：學習，原來不是為了考試，而是理解世界。</p>
    <p>另一個孩子原本害怕數學，但 AI 像朋友一樣，一步一步陪他理解。</p>
    <p>沒有責罵，沒有比較，沒有「你怎麼還不會」。只有慢慢懂了的笑容。</p>
    <p>午後，孩子們走進森林，觀察鳥怎麼築巢、樹怎麼長高、土壤怎麼循環、為什麼森林能彼此共生。</p>
    <p>夜晚，大家圍坐聊天，談未來想成為什麼人、AI 時代什麼最重要、如何找到真正喜歡的事、如何不在競爭裡失去自己。</p>
    <blockquote>森林學校想教孩子的，不是「如何贏過別人」，而是如何一生都保有好奇、熱情、思考能力與自主學習的力量。</blockquote>
    <p>因為未來真正重要的能力，不是背多少答案，而是即使世界快速改變，你仍然能持續學習、持續成長。</p>
    <p>每個孩子都像一顆種子。教育不是催熟，而是給他適合的土壤、陽光與時間。</p>
  </article>
);

export default SceneFourFutureLearning;
